module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo5-f5c975a8d4e5fd5d63070b76b95b965b.jpg";